import { render, staticRenderFns } from "./CursoAudit.vue?vue&type=template&id=47d8ce79"
import script from "./CursoAudit.vue?vue&type=script&lang=js"
export * from "./CursoAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports